import { rae2eci } from '@ootk/src/main';
import { Line, LineColors } from './line';
import { ServiceLocator } from '@app/engine/core/service-locator';
export class SensorToRaeLine extends Line {
    sensor;
    rae;
    constructor(sensor, rae, color) {
        super();
        this.rae = rae;
        this.sensor = sensor;
        this.color_ = color || LineColors.GREEN;
    }
    update() {
        const posData = ServiceLocator.getDotsManager().positionData;
        const id = this.sensor.id;
        const sensorEciArr = [posData[id * 3], posData[id * 3 + 1], posData[id * 3 + 2]];
        const gmst = ServiceLocator.getTimeManager().gmst;
        const raeInEci = rae2eci(this.rae, this.sensor.lla(), gmst);
        const eciArr = [raeInEci.x, raeInEci.y, raeInEci.z];
        this.isDraw_ = true;
        this.updateVertBuf([eciArr, sensorEciArr]);
    }
}
